import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import React, { Component } from 'react';
import 'react-circular-progressbar/dist/styles.css';
import { withRouter } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import whitehandset from '../../../assets/images/whitehandset.svg';
import { BaseUrl, ImageBaseUrl } from "../../../Environment";
import { fetchAPIData } from '../../../service/service';
import MessageForCustomer from '../../modals/MessageForCustomer/MessageForCustomer';
import PersoanlInfoModel from '../../modals/PersonInfo modal/PersonInfoModal';
import KycVerification from "../../modals/kycVerification/kycVerification";
import NewCustomerListView from '../NewCustomerListView/NewCustomerListView';
import './NewCustomer.scss';
import { check, cross, editwhite, handset, userdefault, message, deletewhite, plusgreen } from '../../../assets/images';
import { withNamespaces } from 'react-i18next';
import LoadingPage from '../../modals/LoadingPage/LoadingPage';
import NoData from '../../../assets/images/nodata.png';
import excelicon from '../../../assets/images/excelwhite.svg';
import {filter} from '../../../assets/images';
import Axios from "axios";
import { Popover, Stack, Typography, Button } from '@mui/material';
import { getSecureItem } from '../../../utilsFunctions';
import { Check } from '@mui/icons-material';
import { generateCustomerLoanExcel } from './generateCustomerLoanExcel';
import ImageZoomModal from '../../modals/ImageZoomModal';

const axios = require('axios')
class NewCustomerCardView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      branchId: "",
      branches: [],
      idToDelete: null,
      anchorEl: null,
      openmodal: false,
      opendetailmodal: false,
      loginToken: "",
      allCustomer: [],
      allLoans: [],
      status: "",
      row: "",
      cross: "",
      check: "",
      isPersonalInfoActive: false,
      customerInfo: {},
      whiteimage: "none",
      phoneimage: "",
      loading: true,
      sortBy: "name",
      sortOrder: "ASC",
      openKyc: false,
      selectedCustomerId: null,
      kycDetails: [],
      page: 1,
      pageSize: 100,
      totalPages: 1,
    }
    // this.context =this.context.bind(this)
    this.closemodal = this.closemodal.bind(this)
    this.closedetailmodal = this.closedetailmodal.bind(this)
    this.AllCustomerGet = this.AllCustomerGet.bind(this)

  }
  CardOver = (index) => {
    document.getElementById('handset' + index).style.display = "none"
    document.getElementById('whitehandset' + index).style.display = ""
  }
  CardOut = (index) => {
    document.getElementById('handset' + index).style.display = ""
    document.getElementById('whitehandset' + index).style.display = "none"
  }

  fetchBranches = async () => {
    try {
      const token = getSecureItem("token");
      const headers = {
        Authorization: "Bearer " + token,
      };
      const loggedinUser = getSecureItem("loggedinUser");

      const { data } = await axios.get(`${BaseUrl}/branch/getAllBranches`, {
        params: { companyId: loggedinUser?.companyId },
        headers,
      });

      const branchData = loggedinUser?.userType == "superAdmin" ? data?.data : data?.data?.filter((item) => item?.branchId == loggedinUser?.branchId);

      const branches = [
        ...(loggedinUser?.userType === "superAdmin"
          ? [
              {
                id: null,
                name: "Clear (X)",
                isActive: false
              }
            ]
          : []),
        ...(branchData?.map(item => ({
          id: item.branchId,
          name: item.branchName,
          isActive: false
        })) || [])
      ];

      this.setState({ branches });
    } catch (err) {
      console.error("Fetch Branches Error:", err);
    }
  };

  changeBranch = (branch) => {
    let { branches } = this.state;
    const index = branches.indexOf(branch);

    branches = branches.map(b => {
      b.isActive = false;
      return b;
    });

    branches[index].isActive = true;

    this.setState({ branches, branchId: branches[index].id });

    setTimeout(() => {
      this.AllCustomerGet();
    }, 100);
  };

  updateSort = (sortBy, sortOrder) => {
    this.setState(
      {
        sortBy,
        sortOrder,
      },
      () => {
        this.AllCustomerGet();
      }
    );
  };

  async AllCustomerGet() {
    let loggedinUser = getSecureItem("loggedinUserCompany")

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + getSecureItem("token")
    }

    const { page, pageSize } = this.state;

    axios.get(
      `${BaseUrl}/customer/getAllCustomersWithPagination?name=&companyId=${loggedinUser}&sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}&branchId=${this.state.branchId || getSecureItem("loggedinUser")?.branchId || ''}&page=${page}&pageSize=${pageSize}`,
      { headers }
    ).then(resp => {
      if (resp.status === 200) {
        const customers = Array.isArray(resp.data)
          ? resp.data
          : (resp.data?.data || []);

        customers.forEach((item, i) => {
          customers[i].count = Object.keys(item.loans || {}).length;
          if (item.verified === true) {
            this.setState({ cross: "none", check: "initial" })
          } else {
            this.setState({ cross: "initial", check: "none" })
          }
        })

        const totalCount =
          resp.data?.totalRecords ??
          resp.data?.totalCount ??
          parseInt(resp.headers["x-total-count"], 10) ??
          customers.length;
        const totalPages =
          resp.data?.totalPages || Math.max(1, Math.ceil(totalCount / pageSize));

        this.setState({
          allCustomer: customers,
          totalPages,
          loading: false
        })
      } else {
        this.setState({ loading: false })
        toast.error("Please try again!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
        });
      }
    }).catch(err => {
      this.setState({ loading: false })
    })
  }

handlePrevious = () => {
  if (this.state.page > 1) {
    this.setState({ page: this.state.page - 1 }, () => this.AllCustomerGet());
  }
};

handleNext = () => {
  if (this.state.page < this.state.totalPages) {
    this.setState({ page: this.state.page + 1 }, () => this.AllCustomerGet());
  }
};

handlePageChange = (p) => {
  if (p !== this.state.page) {
    this.setState({ page: p }, () => this.AllCustomerGet());
  }
};

getVisiblePages = () => {
  const { page, totalPages } = this.state;
  const delta = 2; // how many pages to show around current page
  const range = [];

  for (
    let i = Math.max(1, page - delta);
    i <= Math.min(totalPages, page + delta);
    i++
  ) {
    range.push(i);
  }

  return range;
};

  async componentDidMount() {
    this.setState({
      loginToken: getSecureItem("token"),
      extrafield1: "none",
      extrafield2: "none",
    })
    await this.fetchBranches();
    this.AllCustomerGet()
  }
  componentDidUpdate(prevProps) {
    const { searchResults } = this.props;

    // Only sync if searchResults actually changed
    if (searchResults === prevProps.searchResults) return;

    if (Array.isArray(searchResults)) {
      // Search is active — trust the result even if empty
      this.setState({ allCustomer: searchResults });
    } else if (searchResults == null && prevProps.searchResults != null) {
      // Search was cleared — reload from API
      this.AllCustomerGet();
    }
  }
  // OnShow(customerId) {

  //   const headers = {
  //     'Content-Type': 'application/json',
  //     'Authorization': 'Bearer ' + getSecureItem("token")
  //   }
  //   if (customerId.verified == null) {
  //     customerId.verified = true;
  //     axios.put(BaseUrl + '/customer/verifyCustomer', customerId, {
  //       headers: headers,
  //     }).then(res => {
  //       if (res.request.status === 200) {
  //         // {this.state.choosecustomer}
  //         let custname = customerId.firstName
  //         toast.success(custname + " " + "Verified Successfully", {
  //           position: "top-center",
  //           autoClose: 2000,
  //           hideProgressBar: true,
  //           closeOnClick: true,
  //           pauseOnHover: false,
  //           draggable: true,
  //         });
  //         // window.location.reload()
  //         this.AllCustomerGet()
  //       }
  //     })
  //   } else {
  //     this.props.history.push({ pathname: '/addloannointerest', params: customerId })
  //   }
  // }
  OnShow = (customer) => {
    const token = getSecureItem("token");
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    };
  
    if (!customer.verified) { // Handles both null and false cases
      axios.put(`${BaseUrl}/customer/verifyCustomer`, { ...customer, verified: true }, { headers })
        .then(res => {
          if (res.status === 200) {
            toast.success(`${customer.firstName} Verified Successfully`, {
              position: "top-center",
              autoClose: 2000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
            });
            this.AllCustomerGet(); // Refresh customer list
          }
        })
        .catch(error => {
          console.log("Error: " + error);
          
          toast.error("Verification failed. Please try again.", {
            position: "top-center",
            autoClose: 2000,
          });
        });
    } else {
      this.props.history.push({ pathname: '/addloannointerest', params: customer });
    }
  };
  
  edit(details) {
    this.props.history.push({ pathname: '/customers/addcustomer', params: details })
  }
  closemodal() {
    this.setState({
      openmodal: false
    })
  }
  closedetailmodal() {
    this.setState({
      opendetailmodal: false
    })
  }
  customerDetails(details) {
    this.setState({
      opendetailmodal: true
    })

  }
  messagecustomer = (details, value) => {
    this.setState({
      openmodal: true,
      row: details
    })
  }

  onProfileCardClk = async customerId => {
    this.AllCustomerGet();
    let { isPersonalInfoActive } = this.state
    isPersonalInfoActive = !isPersonalInfoActive
    this.setState({ isPersonalInfoActive });
    let customerInfo = {}
    if (isPersonalInfoActive) {
      customerInfo = await fetchAPIData('customerDetailByID', customerId)
      this.setState({ customerInfo });
    }
  }

  handleClick = (event) => {
    this.setState({anchorEl: event.currentTarget});
  };

  handleClose = () => {
    this.setState({anchorEl: null});
  };

  deleteCustomer = async (customerId) => {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + getSecureItem("token")
    }

    let collectorId = getSecureItem("userid");
    let data = {
      id: customerId,
      collectorId
    };

    Axios({
      url: `${BaseUrl}/customer/deleteCustomer`,
      method: "POST",
      data: data,
      headers: headers
    })
      .then((res) => {
        if (res.data.msg) {
          this.setState({ customerDetail: {} });
          toast.success(`Deleted Succesfully.`, {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
          });
          this.handleClose();
          this.AllCustomerGet();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  csvExport = async () => {
        try {
      const payLoad = {
        branchId: null,
        collectorId: null,
        companyId: getSecureItem("loggedinUserCompany"),
        fromDate: null,
        loanAmountFrom: null,
        loanAmountTo: null,
        loanPaymentStatus: null,
        // loanStatus: "Open",
        loanTenureType: null,
        loanTypeId: null,
        search: "",
        sortBy: "name",
        sortOrder: "asc",
        toDate: null,
        getFullData: true
      };
      const response = await Axios.post(`${BaseUrl}/loan/getAllLoans`, payLoad, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + getSecureItem("token")
        }
      });
      // console.log("vh", response.data?.data);
      const loans = response.data?.data || [];
      if(loans.length > 0){
        this.setState({ allLoans: loans });
      }
    } catch (error) {
      console.error("Error fetching all loans:", error);
    }
    if (!this.state.allCustomer || this.state.allCustomer.length === 0) {
      toast.error("No customer data available for export.", {
        position: "top-center",
        autoClose: 2000,
      });
      return;
    }
    generateCustomerLoanExcel(this.state.allCustomer, this.state.allLoans);
  };
  
  render() {
    const { t, list } = this.props;
    const { anchorEl, idToDelete, isPersonalInfoActive, customerInfo, loading, allCustomer, branches, kycDetails } = this.state;
  
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
  
    // Configure toast once, not in every render.
    if (!toast.isActive()) toast.configure();   
    
    const userPermissions = getSecureItem("UsersAccess");

    // Loading or No Data conditions
    if (loading) {
      return <LoadingPage isLoading={loading} />;
    }

    // if (allCustomer && allCustomer?.length === 0) {
    //   return (
    //     <div className="absolute-container2">
    //       <img src={NoData} alt='No Data' className="centered-image2" />
    //     </div>
    //   );
    // }
  
    return (
      <div>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          style={{ padding: '10px' }}
          onClose={this.handleClose}
        >
          <Stack spacing={2} style={{ padding: '15px' }}>
            <Typography sx={{ p: 1 }} variant="h6">
              Deleting a customer will delete all the Loan Transaction details. Do you want to Proceed?
            </Typography>
            <Stack direction="row" spacing={2}>
              <Button variant="contained" onClick={this.handleClose} color="error">Cancel</Button>
              <Button variant="contained" onClick={() => this.deleteCustomer(idToDelete)} color="primary">OK</Button>
            </Stack>
          </Stack>
        </Popover>
  
        <div className="sortDropdown">
          <button className="sortDropdown__button">
            Sort By ▸
          </button>

          <ul className="sortDropdown__menu">
            <li className="sortDropdown__item sortDropdown__item--hasSub">
              Created Date
              <ul className="sortDropdown__submenu">
                <li onClick={() => this.updateSort("createdDate", "ASC")}>
                  Ascending
                </li>
                <li onClick={() => this.updateSort("createdDate", "DESC")}>
                  Descending
                </li>
              </ul>
            </li>

            <li className="sortDropdown__item sortDropdown__item--hasSub">
              Customer ID
              <ul className="sortDropdown__submenu">
                <li onClick={() => this.updateSort("cust_id", "ASC")}>
                  Ascending
                </li>
                <li onClick={() => this.updateSort("cust_id", "DESC")}>
                  Descending
                </li>
              </ul>
            </li>

            <li className="sortDropdown__item sortDropdown__item--hasSub">
              Name
              <ul className="sortDropdown__submenu">
                <li onClick={() => this.updateSort("name", "ASC")}>
                  Ascending
                </li>
                <li onClick={() => this.updateSort("name", "DESC")}>
                  Descending
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <FilterMenu
          branches={branches}
          changeBranch={this.changeBranch}
        />

        <Button style={{
          backgroundColor: '#00D95E',
          marginLeft: 20,
          marginTop: -30,
          textTransform: "capitalize",
          color: "#fff",
          fontSize: 16
        }} className="Fonts" onClick={this.csvExport.bind(this)}>
          <img style={{marginRight: 5}} src={excelicon} alt="excelicon"/>
          {"Export Data"}
        </Button>

        {list !== "list" ? (
                allCustomer?.length === 0 ? <div className="absolute-container2">
          <img src={NoData} alt='No Data' className="centered-image2" />
        </div> :<div> <div className="Newcustomercardviewpage">
                  <Grid container spacing={1} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))' }}>
                    {allCustomer && allCustomer?.map((details, index) => (
                      <Grid key={index}>
                        <Card className="CardDiv" onMouseOver={() => this.CardOver(index)} onMouseOut={() => this.CardOut(index)}>
                          <CardHeader
                            avatar={
                              details.proofs?.[0]?.proofImagePath ? (
                                <Avatar aria-label="recipe">
                                  <ImageZoomModal
                                    src={ImageBaseUrl + details.proofs[0].proofImagePath}
                                    alt="Profile picture"
                                    size={40}
                                    borderRadius={10}
                                    allowDownload={true}
                                    fileName="profile.jpg"
                                  />
                                </Avatar>
                              ) : <img src={userdefault} alt='aa' width={"30px"} />
                            }
                            action={
                              <>
                                {userPermissions?.editBorrowers && (
                                  <img
                                    src={editwhite}
                                    alt="editwhite"
                                    onClick={() => this.edit(details.customerId)}
                                    className="editwhite"
                                  />
                                )}
                                {userPermissions?.deleteBorrowers && (
                                  <div
                                    onClick={(e) => {
                                      this.setState({ idToDelete: details.customerId });
                                      this.handleClick(e);
                                    }}
                                  >
                                    <img
                                      src={deletewhite}
                                      alt="deletewhite"
                                      className="deletewhite"
                                    />
                                  </div>
                                )}
                              </>
                            }
                            title={
                              details.firstName && (
                                <div className="NameDiv Fonts">
                                  {details.firstName + " " + details.lastName}
                                </div>
                              )
                            }
                            subheader={
                              <div>
                                <div onClick={() => this.onProfileCardClk(details.customerId)} style={{ cursor: "pointer" }}>
                                  {details.cust_id && (
                                    <div style={{ marginTop: -15 }}>
                                      <p style={{ marginBottom: -5, padding: 0, fontWeight: "bold" }} className="subheadingnameDiv Fonts">
                                        ({details.cust_id})
                                      </p>
                                    </div>
                                  )}
                                  <div className="subheadingnameDiv Fonts">
                                    {details.verified ? t('NewCustomer.verify') : t('NewCustomer.notver')}
                                    <span style={{ paddingLeft: "3px" }}>
                                      <img
                                        src={details.verified ? check : cross}
                                        alt={details.verified ? "check" : "cross"}
                                        className={details.verified ? "checkImage" : "crossImage"}
                                        style={{ width: "10px" }}
                                      />
                                    </span>
                                  </div>
                                  <div className="subheadingnameDiv Fonts">
                                    <img
                                      src={handset}
                                      alt="handset"
                                      id={"handset" + index}
                                      className="handset"
                                      style={{ width: "8px", margin: "0 5px" }}
                                    />
                                    <img
                                      src={whitehandset}
                                      alt="whitehandset"
                                      id={"whitehandset" + index}
                                      className="whitehandset"
                                      style={{ width: "8px", margin: "0 5px", display: 'none' }}
                                    />
                                    {details.phone}
                                  </div>
                                </div>
                                <div style={{ marginTop: 8 }}>
                                  {details.kycVerified ? (
                                    <div
                                      onClick={() =>
                                        this.setState({
                                          openKyc: true,
                                          selectedCustomerId: details.customerId,
                                          kycDetails: details.kycDetails || [],
                                          kycVerified: true,
                                        })
                                      }
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: 6,
                                        padding: "4px 10px",
                                        borderRadius: 20,
                                        background: "#e8f5e9",
                                        color: "#2e7d32",
                                        fontSize: 12,
                                        fontWeight: 600,
                                        cursor: "pointer",
                                      }}
                                    >
                                      <img
                                        src={check}
                                        alt={"check"}
                                        className={"checkImage"}
                                        style={{ width: "10px" }}
                                      /> KYC Verified
                                    </div>
                                  ) : (
                                    <div
                                      onClick={() =>
                                        this.setState({
                                          openKyc: true,
                                          selectedCustomerId: details.customerId,
                                          kycVerified: false,
                                        })
                                      }
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: 6,
                                        padding: "4px 10px",
                                        borderRadius: 20,
                                        background: "#FFF9E5",
                                        color: "#FFA500",
                                        fontSize: 12,
                                        fontWeight: 600,
                                        cursor: "pointer",
                                      }}
                                    >
                                      ⚠️ KYC Pending
                                    </div>
                                  )}
                                </div>
                              </div>
                            }
                          />
                          {userPermissions?.addLoan && <CardContent>
                            {/* {details.verified !== null && (
                              <button className={details.verified ? "AddloanButton" : "VerifyButton"} onClick={() => this.OnShow(details)}>
                                <img
                                  src={details.verified ? plusgreen : undefined}
                                  alt={details.verified ? "plusgreen" : undefined}
                                  className={details.verified ? "plusgreenButton" : undefined}
                                />
                                <span>{details.verified ? t('NewCustomer.addloanbtn') : t('NewCustomer.verifybtn')}</span>
                              </button>
                            )} */}
                            <button 
                              className={details.verified ? "AddloanButton" : "VerifyButton"} 
                              onClick={() => this.OnShow(details)}
                            >
                              <img
                                src={details.verified ? plusgreen : undefined}
                                alt={details.verified ? "plusgreen" : undefined}
                                className={details.verified ? "plusgreenButton" : undefined}
                              />
                              <span>{details.verified ? t('NewCustomer.addloanbtn') : t('NewCustomer.verifybtn')}</span>
                            </button>
                          </CardContent>}
                          <CardActions disableSpacing>
                            <div style={{ display: 'flex', width: '100%', cursor: "pointer" }} onClick={() => this.onProfileCardClk(details.customerId)}>
                              <div className="footerDiv1">
                                {details.createdAt && <div className="footerDivdate Fonts">{moment(details.createdAt).format("DD MMM YYYY")}</div>}
                                <div className="footerDivdatedetails Fonts">{t('NewCustomer.Date')}</div>
                              </div>
                              <div className="footerDiv2" style={{flexDirection: "column"}}>
                                {details.count && <div className="footerDivmonth Fonts">{details.count}</div>}
                                <div className="footerDivmonthdetails Fonts">{t('NewCustomer.loans')}</div>
                              </div>
                            </div>
                          </CardActions>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                  <MessageForCustomer open={this.state.openmodal} close={this.closemodal} rowData={this.state.row} />
                  {isPersonalInfoActive && <PersoanlInfoModel open={isPersonalInfoActive} close={this.onProfileCardClk}  customerInfo={customerInfo} mainPage={true} />}
              <KycVerification
                open={this.state.openKyc}
                onClose={() => this.setState({ openKyc: false })}
                customerId={this.state.selectedCustomerId}
                kycDetails={this.state.kycDetails}
                kycVerified={this.state.kycVerified}
                onSuccess={this.AllCustomerGet}
              />
            </div>
            {this.state.totalPages > 1 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "20px",
                    alignItems: "center",
                  }}
                >
                  <Button
                    onClick={this.handlePrevious}
                    disabled={this.state.page === 1}
                    style={{ marginRight: "10px" }}
                    variant="outlined"
                  >
                    Previous
                  </Button>

                  {this.getVisiblePages().map((p) => (
                    <Button
                      key={p}
                      variant={this.state.page === p ? "contained" : "outlined"}
                      onClick={() => this.handlePageChange(p)}
                      style={{ margin: "0 5px" }}
                    >
                      {p}
                    </Button>
                  ))}

                  <Button
                    onClick={this.handleNext}
                    disabled={this.state.page === this.state.totalPages}
                    style={{ marginLeft: "10px" }}
                    variant="outlined"
                  >
                    Next
                  </Button>
                </div>
              )}
              </div>
        ) : (
          allCustomer?.length === 0 ? <div className="absolute-container2">
          <img src={NoData} alt='No Data' className="centered-image2" />
        </div> : <NewCustomerListView />
        )}
      </div>
    );
  }
  
}
export default withNamespaces()(withRouter(NewCustomerCardView));

const FilterMenu = ({ branches, changeBranch }) => {
  return (
    <div className="collectionfilterbuttonpage">
      <div className="hoverFunction">
        <button className="filterButton">
          Filters
          <img src={filter} alt="filter" className="filterImg"/>
        </button>

        <ul className="hoverMenu" style={{zIndex: 9999}}>

          {/* Branch */}
          <li className="menuList">
            <a>Branch</a>

            <ul className="subList" style={{left: 225, }}>
              {branches?.map((branch) => (
                <li
                  key={branch.id}
                  className="subListMenu"
                  onClick={() => changeBranch(branch)}
                >
                  {branch.name}
                  {branch.isActive && <Check className="menuIcon"/>}
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
};